import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface LanguageState {
  interfaceLanguage: 'uk' | 'ru' | 'en';
}

const initialState: LanguageState = {
  interfaceLanguage: 'uk',
};

export const languageSlice = createSlice({
  name: 'languages',
  initialState,
  reducers: {
    // Reducer comes here
    setInterfaceLanguage: (state, action: PayloadAction<'uk' | 'ru'>) => ({ ...state, interfaceLanguage: action.payload }),
  },
  extraReducers: {},
});

const { actions, reducer } = languageSlice;
// Extract and export each action creator by name
export const { setInterfaceLanguage } = actions;
// Export the reducer, either as a default or named export
export default reducer;
